import type { GeoLocation } from '@smg-real-estate/geo-libs';

import { haveSameSearchedGeoIds } from '@/stores/geoLocationHelpers';
import { ListingType, SortingOption } from '@/types';

/** Fallback when listing type and sort combo is invalid. */
export const getAgencySortByOption = (
  sortOption: SortingOption,
  listingType: ListingType,
): SortingOption => {
  if (
    (listingType === ListingType.SALE && sortOption === SortingOption.PROPERTIES_FOR_RENT) ||
    (listingType === ListingType.RENT && sortOption === SortingOption.PROPERTIES_FOR_SALE)
  ) {
    return SortingOption.DEFAULT;
  }

  return sortOption;
};

export interface AgencySearchIdentity {
  resolvedLocations: GeoLocation[];
  currentPage: number;
  searchedLocations: GeoLocation[] | null | undefined;
  loadedPage: number;
  includeChildren: boolean;
  loadedIncludeChildren: boolean;
  listingType: ListingType;
  loadedListingType: ListingType;
  sortBy: SortingOption;
  loadedSortBy: SortingOption;
}

/** True when resolved locations, page, and agency filters match the already-loaded search. */
export const isSameAgencySearch = ({
  resolvedLocations,
  currentPage,
  searchedLocations,
  loadedPage,
  includeChildren,
  loadedIncludeChildren,
  listingType,
  loadedListingType,
  sortBy,
  loadedSortBy,
}: AgencySearchIdentity): boolean => {
  if (currentPage !== loadedPage) {
    return false;
  }

  if (
    includeChildren !== loadedIncludeChildren ||
    listingType !== loadedListingType ||
    getAgencySortByOption(sortBy, listingType) !== loadedSortBy
  ) {
    return false;
  }

  return haveSameSearchedGeoIds(searchedLocations, resolvedLocations);
};
